
require('jquery');
require('blueimp-file-upload');
require('blueimp-file-upload/js/jquery.iframe-transport.js');

